module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Bold.49f319b415ccfc7ec1c30fed24d592c4.ttf";